import React from 'react';
import SEO from '../../components/common/SEO';
import Hero from '../../components/sections/Hero';
import AboutIntro from '../../components/sections/About';
import Services from '../../components/sections/Services';
import Events from '../../components/sections/Events';
import Testimonials from '../../components/sections/Testimonials';
import Instagram from '../../components/sections/Instagram';
import Newsletter from '../../components/common/Newsletter';

const Home = () => {
  return (
    <>
      <SEO
        title="KO Holistic Health | Reiki, Tarot & Holistic Healing Sydney"
        description="Sydney's trusted holistic health practitioner. Reiki healing, tarot readings, soul coaching, chakra healing, meditation classes & spiritual guidance. Book with Kirstie Warburton today."
        keywords="reiki healing sydney, tarot reading sydney, soul coaching, meditation classes sydney, chakra healing, spiritual guidance sydney, holistic health practitioner, energy healing, crystal healing, reiki master sydney, holistic wellness, kirstie warburton, space clearing, restorative reiki classes, holistic therapist near me"
        url="/"
      />
      <Hero />
      <AboutIntro />
      <Services />
      <Testimonials />
      <Events />
      <Instagram />
      <Newsletter />
    </>
  );
};

export default Home;
